<script>
import HsSectionCard from "@/base/hs-tableview/hs-section/hs-section-card.vue";
import HsVanSwitch from "@/base/hs-switch/hs-van-switch.vue";
import HsFormCell from "@/base/hs-tableview/hs-section/hs-form-cell.vue";

export default {
  props: {
    currentDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    OrderBusinessType: {
      type: Number,
      default: 0
    },
  },
  computed: {
    BookingSMSSetting() {
      let show = (this.OrderBusinessType === 1 || this.OrderBusinessType === 18) && this.getSetting('常用配置:预订消息:展示')
      return {
        Show: show,
        Name: this.$t('BookingSMS')
      }
    },
    TicketingSMSSetting() {
      let show = (this.OrderBusinessType === 1 || this.OrderBusinessType === 6 || this.OrderBusinessType === 10 || this.OrderBusinessType === 18)
      return {
        Show: show,
        Name: this.$t('TicketingSMS')
      }
    },
    BookingMailSetting() {
      let show = (this.OrderBusinessType === 1 || this.OrderBusinessType === 18) && this.getSetting('常用配置:预订消息:展示')
      return {
        Show: show,
        Name: this.$t('BookingMail')
      }
    },
    TicketingMailSetting() {
      let show = this.OrderBusinessType === 1 || this.OrderBusinessType === 6 || this.OrderBusinessType === 10 || this.OrderBusinessType === 18
      return {
        Show: show,
        Name: this.$t('TicketingMail')
      }
    },
    ConfirmSMSSetting() {
      return {
        Show: this.OrderBusinessType === 2 || this.OrderBusinessType === 11 || this.OrderBusinessType === 14,
        Name: this.OrderBusinessType === 14 ? this.$t('IsSendReceiveSms') : this.$t('ConfirmSMS')
      }
    },
    ConfirmMailSetting() {
      return {
        Show: this.OrderBusinessType === 2 || this.OrderBusinessType === 11 || this.OrderBusinessType === 14,
        Name: this.OrderBusinessType === 14 ? this.$t('IsSendReceiveEmail') : this.$t('ConfirmMail')
      }
    },
  },
  components: {
    HsFormCell,
    HsVanSwitch,
    HsSectionCard
  }
}
</script>

<template>
  <hs-section-card :title="$t('Notice')">
    <div class="details">
      <!--预订短信-->
      <hs-form-cell v-if="BookingSMSSetting.Show" :title="BookingSMSSetting.Name" :show-separator="false">
        <div class="cell">
          <hs-van-switch v-model="currentDetails.IsSendBookSms" size="25" :active-color="'#f0182a'" :inactive-color="'#e3e1e1'" />
        </div>
      </hs-form-cell>
      <!--出票短信-->
      <hs-form-cell v-if="TicketingSMSSetting.Show" :title="TicketingSMSSetting.Name" :show-separator="false">
        <div class="cell">
          <hs-van-switch v-model="currentDetails.IsSendIssuedSms" size="25" :active-color="'#f0182a'" :inactive-color="'#e3e1e1'" />
        </div>
      </hs-form-cell>
      <!--预订邮件-->
      <hs-form-cell v-if="BookingMailSetting.Show" :title="BookingMailSetting.Name" :show-separator="false">
        <div class="cell">
          <hs-van-switch v-model="currentDetails.IsSendBookEmail" size="25" :active-color="'#f0182a'" :inactive-color="'#e3e1e1'" />
        </div>
      </hs-form-cell>
      <!--出票邮件-->
      <hs-form-cell v-if="TicketingMailSetting.Show" :title="TicketingMailSetting.Name" :show-separator="false">
        <div class="cell">
          <hs-van-switch v-model="currentDetails.IsSendIssuedEmail" size="25" :active-color="'#f0182a'" :inactive-color="'#e3e1e1'" />
        </div>
      </hs-form-cell>

      <!--确认短信 接单短信-->
      <hs-form-cell v-if="ConfirmSMSSetting.Show" :title="ConfirmSMSSetting.Name" :show-separator="false">
        <div class="cell">
          <hs-van-switch v-model="currentDetails.IsSendConfirmSms" size="25" :active-color="'#f0182a'" :inactive-color="'#e3e1e1'" />
        </div>
      </hs-form-cell>
      <!--确认邮件 接单邮件-->
      <hs-form-cell v-if="ConfirmMailSetting.Show" :title="ConfirmMailSetting.Name" :show-separator="false">
        <div class="cell">
          <hs-van-switch v-model="currentDetails.IsSendConfirmEmail" size="25" :active-color="'#f0182a'" :inactive-color="'#e3e1e1'" />
        </div>
      </hs-form-cell>
    </div>
  </hs-section-card>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.details{
  width: 100%;
  .cell{
    @extend .flex-end;
    width: 100%;
  }
}
</style>
